import request from '@/utils/request'

export function list(query) {
    return request({
        url: '/mall/type/list',
        method: 'get',
        params: query
    })
}

export function info(id) {
    return request({
        url: '/mall/type/info/' + id,
        method: 'get'
    })
}

export function save(data) {
    return request({
        url: '/mall/type/save',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: '/mall/type/update',
        method: 'post',
        data
    })
}

export function remove(data) {
    return request({
        url: '/mall/type/delete',
        method: 'post',
        data
    })
}

